import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { CONFIRM_DIALOG_I18N } from "./confirm-dialog.i18n";

export type ConfirmDialogVariant = 'default' | 'danger';

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
  imports: SHARED_IMPORTS,
})
export class ConfirmDialogComponent implements OnInit {
  noButtonText = CONFIRM_DIALOG_I18N.button.no;
  confirmButtonText = CONFIRM_DIALOG_I18N.button.yes;
  variant: ConfirmDialogVariant = 'default';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<any>,
  ) {
    if (data.confirmButtonText != null) {
      this.confirmButtonText = data.confirmButtonText;
    }
    if (data.variant != null) {
      this.variant = data.variant;
    }
  }

  ngOnInit(): void {}

  onNoClick(): void {
    this.matDialogRef.close();
  }
}
